<template>
  <div class="article">
    <layout-detail>
      <template slot="left">
        <div class="list-search-bar-container">
          <source-select-box
            v-model="pgData"
            defaultFileType=""
            collectionUrl="/user/collect?tabValue=library"
            :fileTypes="fileTypes"
            :showDetailSearch="true"
            :data="sourceTypes"
            @search="searchHandler"
            @fileTypeChange="fileTypeChange"
            :visitlocation="'个人中心-我的收藏'"
          >
          </source-select-box>
        </div>

        <div class="left-list" v-loading="pageLoading">
          <layout-card>
            <div v-if="tableData.length">
              <list-item
                class="item"
                v-for="(item, index) in tableData"
                :key="index"
                :data="item"
                :action="`${$store.state.api.baseWebUrl}/yzkj/information/detail`"
                collectType="7"
                retype="information"
                v-czc="[
                  '政策法规库',
                  '点击列表',
                  '政策法规列表',
                  index + 1,
                  `library-list-libraryList`,
                ]"
              >
              </list-item>
            </div>

            <empty-list v-else>
              <span>暂无数据</span>
            </empty-list>
            <my-pagination
              ref="page"
              v-model="tableData"
              :action="`${$store.state.api.baseWebUrl}/yzkj/information/search`"
              :loading.sync="pageLoading"
              :search="pgData"
              @currentChange="currentChange"
            ></my-pagination>
          </layout-card>
        </div>
      </template>

      <template slot="right">
        <img
          src="@/assets/images/watch/1.png"
          alt=""
          style="margin-bottom: 10px; border-radius: 5px"
        />

        <layout-card class="ceiling">
          <template slot="head"> 搜索热榜 </template>

          <section-hot
            :mdData="hotData"
            action="/yzkj/information/records/hostList"
            type="information"
          />
        </layout-card>
      </template>
    </layout-detail>
  </div>
</template>

<script>
import CONFIG_PROJECT from "@config/project";

import SearchBar from "@components/sys/list-search-bar-item";
import SourceSelectBox from "./components/source-select-box.vue";

import EmptyList from "@components/sys/empty-list";

import ListItem from "./components/list-item";
import SectionHot from "./sections/section-hot";

import LayoutDetail from "@components/sys/layout-detail";
import LayoutCard from "@components/sys/layout-card";
import LoadList from "./components/loadList.vue";

import appNode from "@js/app-node";
import Ceiling from "@js/Ceiling";

export default {
  head: {
    title: `政策法规库·${CONFIG_PROJECT.title}`,
  },
  components: {
    LayoutDetail,
    LayoutCard,
    ListItem,
    SectionHot,
    SearchBar,
    SourceSelectBox,
    EmptyList,
    LoadList,
  },
  async asyncData(context) {
    let fileTypes = [
      {
        dictName: "全部",
        dictCode: "",
        informationType: "1",
      },
      {
        dictName: "常用",
        dictCode: "常用",
        informationType: "",
      }
    ];

    let [sourceTypes] = await Promise.all([
      appNode.ssrReq
        .call(context, `${context.store.state.api.baseWebUrl}/yzkj/dict/treeList`, {
          dictCode: "source_plat",
        })
        .then((data) => {
          return data;
        }),
    ]);

    return {
      fileTypes,
      sourceTypes,
    };
  },
  watch: {
    // 'pgData': {
    //     handler(n,o){
    //         this.searchHandler();
    //     },
    //     deep: true,
    // }
  },
  data: () => ({
    pgData: {
      pageIndex: 1,
      pageSize: 10,
      sortOrder: "ASC",
      sourceStrs: "",
      title: "",
      informationTag: "",
      informationType: "1",
      startTime: "",
      endTime: "",
      sortName: "",
    },
    sourceType: "",
    tableData: [],

    pageLoading: false,
    hotData: {
      category: "政策法规库",
      action: "点击列表",
      label: "搜索热榜",
      nodeid: "library-list-hotSearch",
    },
  }),
  methods: {
    fileTypeChange(val, index) {
      this.pgData.informationTag = val.dictCode;
      this.pgData.informationType = val.informationType;
      this.setCzc(["政策法规库", "筛选", "行业分类", index, "library-select-fileType"]);
      this.searchHandler();
    },

    searchHandler() {
      if (this.$refs.page) {
        this.$refs.page.queryData();
      }
    },

    // 分类
    getDict() {
      this.$get(
        `${this.$store.state.api.baseWebUrl}/yzkj/dict/list`,
        {
          dictCode: "major",
        },
        (data) => {
          // console.log(data);
        }
      );
    },
    //获取 来源
    getTreeList() {
      this.$get(
        `${this.$store.state.api.baseWebUrl}/yzkj/dict/treeList`,
        {
          dictCode: "source_plat",
        },
        (data) => {
          this.sourceTypes = data;
        }
      );
    },

    currentChange(val) {
      this.setCzc([
        "政策法规库",
        "翻页",
        "文件列表",
        val.nowPage,
        "library-page-libraryList",
      ]);
    },
  },
  created() {
    this.$store.dispatch("analysis/updateHits", {
      visitlocation: "政策法规",
    });
  },
  mounted() {
    new Ceiling({
      el: document.querySelector(".ceiling"),
    });
    // this.getDict();
    // this.getTreeList();
    if (this.$route.query.title) {
      this.pgData.title = this.$route.query.title;
    }
    this.searchHandler();
  },
};
</script>

<style lang="scss" scoped>
.page {
  margin-top: 20px;
}

.item {
  & + .item {
    border-top: 1px solid #e7e7e7;
    margin-top: 0;
    padding-top: 20px;
  }
}

.left-list {
  min-height: 500px;
}
</style>
